import { styled } from "styled-components";

export const RootContainer = styled.div<{
  $width: number;
}>`
  width: ${(props) => props.$width + "px"};
  /* height: 100dvh; */
  min-height: 100dvh;
  max-width: 480px;
  background-color: #fff6f5;
  margin: 0 auto;
  overflow: hidden;

  img {
    max-width: 100%;
    object-fit: cover;
  }

  span {
    margin: unset;
  }

  /* Firefox */
  input[type="date"] {
    appearance: none;
    -moz-appearance: textfield;
    &::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }
  }

  input,
  textarea {
    border: none;
    outline: none;
    &:focus-visible {
      border: none;
      outline: none;
    }
  }

  a {
    text-decoration: none; /* Removes underline */
    color: inherit; /* Inherits text color from parent */
  }
`;
